import { useEffect } from 'react';

import { storage } from 'APP/packages/storage';

export function useDirectionHandlerPresenter(): void {
  useEffect(() => {
    const directionValue = storage.language.get() === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', directionValue);
  }, []);
}
